import withConfigTransport from '../../../services/config-transport/withConfigTransport'
import _VaDataTableThRow from './VaDataTableThRow.vue'

export const VaDataTableThRow = withConfigTransport(_VaDataTableThRow)
